import React from 'react';
import DashboardHeader from './DashboardHeader';

const headerStyle = {
  backgroundColor: '#f8f8f8',
  padding: '20px',
  textAlign: 'center',
  borderBottom: '1px solid #ddd'
};

const navStyle = {
  marginTop: '5px'
};

const linkStyle = {
  margin: '0 10px',
  textDecoration: 'none',
};

const Header = () => {
  return (
    <header style={headerStyle}>
      <h1>Chemical Tracker</h1>
      {/* Include DashboardHeader if intended */}
      <DashboardHeader />
      <nav style={navStyle}>
        <a href="/admin" style={linkStyle}>Admin</a>
      </nav>
    </header>
  );
};

export default Header;